<template>
  <div
    v-show="list"
    :class="!!showPaddingTop?'step-top':''"
    class="stepBar flex">
    <div
      v-for="(item,key) in list"
      :key="key"
      class="flex flex1 double-center ljb-md-text step-base ">
      <div
        v-if="step<(key+1)"
        class="step-item flex double-center flex1">
        <div
          :class="key<=0?'step-line-white':''"
          class="step-line-gray"/>
        <div class="step-line-text-gray">{{ key+1 }}</div>
        <div
          :class="key>=list.length-1?'step-line-white':''"
          class="step-line-gray"/>
      </div>
      <div
        v-else-if="step==(key+1)"
        class="step-item flex double-center flex1">
        <div
          :class="key<=0?'step-line-white':''"
          class="step-line"/>
        <div class="step-line-text">
          <div class="step-line-text-child">{{ key+1 }}</div>
        </div>
        <div
          :class="key>=list.length-1?'step-line-white':''"
          class="step-line-gray"/>
      </div>
      <div
        v-else
        class="step-item flex double-center flex1">
        <div
          :class="key<=0?'step-line-white':''"
          class="step-line"/>
        <div class="step-line-text">
          <div class="step-line-text-child">{{ key+1 }}</div>
        </div>
        <div
          :class="key>=list.length-1?'step-line-white':''"
          class="step-line"/>
      </div>
      <p class="step-text">{{ item }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListStepNew',
  components: {},
  props: {
    data: {
      type: Object,
      default: function () {
        // return {
        //   list: []
        // }
      }
    },
    stepBar: {
      type: Object,
      default: function () {
      }
    },
    showPaddingTop: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    list () {
      if (this.data) {
        return (this.data && this.data.list) || []
      } else
      if (this.stepBar) {
        return (this.stepBar && this.stepBar.list) || []
      }
    },
    step () {
      if (this.data) {
        if (this.data.step) {
          return this.data.step
        }
        if (this.data.list) {
          return this.data.list.length
        }
      } else if (this.stepBar) {
        if (this.stepBar.step) {
          return this.stepBar.step
        }
        if (this.stepBar.list) {
          return this.stepBar.list.length
        }
      }
      return 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .stepBar{
    padding: 0 $padding $padding $padding;
    background-color: white;
    width: 100%;
    box-sizing: border-box;
  }
  .step-top{
    padding-top: $padding;
  }
  .step-item{
    flex-direction: row;
    width: 100%;
    height: 100%;
    flex: 1;
  }
  .step-line{
    flex: 1;
    height: 3px;
    // background-color: $base-color;
    border-top: 1px dashed #E9BA66;
    margin-top: 4px;
  }

  .step-line-gray{
    border-top: 1px dashed #ccc;
    background-color: #fff;
    @extend .step-line
  }
  .step-line-white{
    background-color: white;
    border-top: 1px dashed #fff;
  }
  .step-line-text{
    width: 24px;
    height: 24px;
    margin: 2px;
    border-radius: 50%;
    background: linear-gradient(90deg, #EBD2A8 0%, #E9BA66 100%);
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    background-image: url(https://cdn.51ljb.cn/ljb_icons_service_dashed.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .step-line-text-child{
      position: absolute;
      width: 20px;
      height: 20px;
      margin: 2px auto;
      left: 2px;
      right: 2px;
      border-radius: 50%;
      background: linear-gradient(90deg, #EBD2A8 0%, #E9BA66 100%);
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      color: #402200;
    }
  }
  .step-line-text-gray{
    background-color: #ccc;
    width: 20px;
    height: 20px;
    margin: 2px;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    // border-top: 1px dashed #ccc;
    // @extend  .step-line-text
  }
  .step-text{
    margin-top: 9px;
    font-size: 11px;
    color: $text-color;
  }
  .step-base{
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/ListStepNew.vue